/* eslint-disable no-unused-vars */
import React, { useContext, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import useFormValidator from 'useFormValidator';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import * as actions from '../../../../action';
import * as c from '../../../../constant';

function CreateDetailsModal({
  newTaxRevenuesId,
  calculationsId,
  createDetails,
  getDetailsList,
  creating,
}) {
  const [formData, setFormData] = useState({
    from: '',
    to: '',
    amount: '',
  });

  const validateForm = useFormValidator(formData, {
    from: 'required|amount',
    to: 'required|amount',
    amount: 'required|amount',
  });
  const setModal = useContext(ModalContext);

  const handleOnSubmit = e => {
    e.preventDefault();
    if (!validateForm.response.is_passed) {
      return false;
    }

    return createDetails(newTaxRevenuesId, calculationsId, formData, () => {
      setModal({ isOpen: false });
      getDetailsList(newTaxRevenuesId, calculationsId);
    });
  };

  const closeModal = e => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  useEffect(() => {
    validateForm.validate();
  }, [Object.values(formData).join(',')]);

  const onChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            <label className="full-label mb-0">
              From: {validateForm.renderMessage('from')}
            </label>
            <input
              className="form-control"
              type="number"
              name="from"
              onChange={onChange}
              placeholder="Ex. 0.00"
              value={_.get(formData, 'from')}
            />
          </div>
          <div className="col-12 form-group">
            <label className="full-label mb-0">
              To: {validateForm.renderMessage('to')}
            </label>
            <input
              className="form-control"
              type="number"
              name="to"
              onChange={onChange}
              placeholder="Ex. 0.00"
              value={_.get(formData, 'to')}
            />
          </div>
          <div className="col-12 form-group">
            <label className="full-label mb-0">
              Amount: {validateForm.renderMessage('amount')}
            </label>
            <input
              className="form-control"
              type="number"
              name="amount"
              onChange={onChange}
              placeholder="Ex. 0.00"
              value={_.get(formData, 'amount')}
            />
          </div>
        </div>

        <div className="d-flex justify-content-center">
          <button
            disabled={creating || !validateForm.response.is_passed}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary     mr-3"
          >
            <span className="font-weight-bold">
              {creating ? <i className="fa fa-spin fa-spinner" /> : `Submit`}
            </span>
          </button>
          <button
            disabled={creating}
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

CreateDetailsModal.propTypes = {
  newTaxRevenuesId: PropTypes.string.isRequired,
  calculationsId: PropTypes.string.isRequired,
  createDetails: PropTypes.instanceOf(Function).isRequired,
  getDetailsList: PropTypes.instanceOf(Function).isRequired,
  creating: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ api }) => ({
  creating: api.loading.indexOf(c.CREATE_DETAILS_PERMIT) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(CreateDetailsModal);
